import styled from 'styled-components';
import { ReactElement } from 'react';

import { StyledFlex } from '@dreryk/react-components';

import { FacilityDescription } from './FacilityDescription';

type DocplannerAddressRowDetailsFacilityDescriptionProps = {
   readonly facilityName: string;
   readonly facilityAddress: string;
};

const StyledDocplannerAddressRowDetailsFacilityDescription = styled(StyledFlex)`
   padding: 9px 0;
`;
StyledDocplannerAddressRowDetailsFacilityDescription.displayName =
   'StyledDocplannerAddressRowDetailsFacilityDescription';

export const DocplannerAddressRowDetailsFacilityDescription = (
   props: DocplannerAddressRowDetailsFacilityDescriptionProps
): ReactElement => {
   return (
      <StyledDocplannerAddressRowDetailsFacilityDescription direction={'column'}>
         <FacilityDescription name={props.facilityName} address={props.facilityAddress} />
      </StyledDocplannerAddressRowDetailsFacilityDescription>
   );
};
